<template>
<div class="card">
  <div class="card-header">
    <div class="form-inline">
      <div class="input-group" :class="{'has-danger': errors.has('identifier') || errors.has('value') }">
        <input class="form-control mr-sm-2" type="text" name="identifier" placeholder="identificador" v-model="searchData.key" v-validate="'required'">
        <input class="form-control mr-sm-2" type="text" name="value" placeholder="valor" v-model="searchData.value" v-validate="'required'">
        <button type="button" class="btn btn-sm btn-secondary my-2 my-sm-0" @click.prevent="search"><i class="fa fa-search"></i> Buscar</button>
      </div>
    </div>
  </div>
  <div class="card-block">
    <div class="container">

      <!-- Tela inicial -->
      <div class="jumbotron text-center" v-if="state == 'initial'">
        <h1 class="display-3">Timeline</h1>
        <p class="lead">Para exibir a jornada do cliente, preencha os dados de busca.</p>
        <hr class="my-4">
      </div>
      <div v-else>
        <!-- Quando mais de uma entidade foi encontrada -->
        <div class="row justify-content-center" v-show="state == 'entities'">
          <div class="col-md-4 col-sm-6" v-for="entity in entities">
            <div class="card card-default">
              <div class="card-block">
                <div class="h1 text-muted text-right">
                  <i class="icon-user"></i>
                </div>
                <table class="table table-sm">
                  <thead>
                    <tr>
                      <th>Campo</th>
                      <th>Valor</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(value, key) in entity.content">
                      <td>{{key}}</td>
                      <td>{{value}}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div class="card-footer">
                <button type="button" class="btn btn-sm btn-secondary" @click.prevent="select(entity)">Selecionar</button>
              </div>
            </div>
          </div>
        </div>

        <!-- Jornada de uma entidade -->
        <ul class="timeline" v-show="state == 'events'">
          <li v-for="(item, index) in orderedEvents" :class="{ 'timeline-inverted': (index%2)==0 }">
            <div class="timeline-badge mutant"><i v-bind:class="getIcon(item.eventType)"></i></div>
            <div class="timeline-panel">
              <div class="card">
                <div class="card-header">
                  {{item.eventType}} <span class="text-muted">(via {{item.through}})</span>
                  <div class="float-right"><i class=  "fa fa-clock-o"></i> {{item.when | formatDate}}</div>
                </div>
                <div class="card-block">
                  <h5 v-for="(identity, index) in item.identifiers">                    
                    <span v-if="identity.value != ''" class="badge badge-pill badge-default">{{identity.key}}: {{identity.value}}</span>                    
                  </h5>
                </div>
              </div>
            </div>
          </li>
        </ul>
      </div>

    </div>
  </div>
</div>
</template>

<script>
import axios from 'axios'

export default {
  name: 'dashboard',
  data() {
    return {
      searchData: {
        key: '',
        value: ''
      },
      entities: [],
      events: [],
      state: 'initial' // [initial | entities | events]
    }
  },
  computed: {
    orderedEvents: function () {
      return this.events.sort((a, b) => {
        return Date.parse(b.when) - Date.parse(a.when)
      })
    }
  },
  created() {},
  methods: {
    search() {
      this.$validator.validateAll()
      if (!this.errors.any()) {
        this.state = 'entities'
        this.events = []
        // chamar api para consulta dos eventos
        axios.get(process.env.API_URL + 'timeline/search?key=' + this.searchData.key + '&value=' + this.searchData.value, {
          withCredentials: true,
          headers: { Authorization: this.accessKey }}).then(response => {
            if (response.data.length === 0) {
              this.showInfo('Pessoa não encontrada!')
            }

            this.entities = response.data
          }).catch(err => {
            console.log(err)
            this.showError('Ops. Ocorreu um erro ao carregar o Timeline.')
          })
      }
    },
    select(entity) {
      this.state = 'events'

      axios.get(process.env.API_URL + 'timeline/events?id=' + entity.id, {
        withCredentials: true,
        headers: { Authorization: this.accessKey }}).then(response => {
          this.events = response.data
        }).catch(err => {
          console.log(err)
          this.showError('Ops. Ocorreu um erro ao carregar o Timeline.')
        })
    },
    getIcon(eventType) {
      var icon = 'fa fa-bolt'

      // TODO: migrar talvez para um DMN
      switch (eventType) {
        case 'ReactivationInviteSent':
          icon = 'fa fa-envelope-o'
          break
        case 'ReactivateInviteAccepted':
          icon = 'fa fa-commenting-o'
          break
        case 'FirstQuestionAnswered':
          icon = 'fa fa-commenting-o'
          break
        case 'SecondQuestionAnswered':
          icon = 'fa fa-commenting-o'
          break
        case 'ThirdQuestionAnswered':
          icon = 'fa fa-commenting-o'
          break
        case 'ReminderInviteSent':
          icon = 'fa fa-tablet'
          break
        case 'LastCallInviteSent':
          icon = 'fa fa-tablet'
          break
        case 'NoOffersChosen':
          icon = 'fa fa-thumbs-down'
          break
        case 'OfferChosen':
          icon = 'fa fa-thumbs-up'
          break
        case 'ServiceReactivated':
          icon = 'fa fa-check'
          break
      }

      return icon
    }
  }
}
</script>

<style>
.timeline-badge.mutant {
  background-color: #11171a !important;
}
</style>



// WEBPACK FOOTER //
// Timeline.vue?187779f4